import * as localeKr from './kr';
import * as localeEn from './en';

export const kr = {
    ...localeKr
};
export const en = {
    ...localeEn
};